import React, { useState } from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import PageTitle from "../components/PageTitle";
import { siteInfo, serviceOptionsForForm } from "../data/mock";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", message: "", agree: false });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.agree) return;
    setSent(true);
    setTimeout(() => setSent(false), 4000);
    setForm({ name: "", email: "", phone: "", service: "", message: "", agree: false });
  };

  return (
    <div>
      <PageTitle title="Contact Us" crumbs={[{ label: "Contact Us" }]} />
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-6">
          {[
            { icon: MapPin, title: "Mamtesh Gupta Heart Center", lines: [siteInfo.fullAddress] },
            { icon: Mail, title: "Contact Us", lines: [siteInfo.email, `Call Us : ${siteInfo.phoneFull}`] },
            { icon: Clock, title: "OPD Hours", lines: [siteInfo.hours.weekday, siteInfo.hours.sunday, siteInfo.hours.emergency] },
          ].map((c, i) => (
            <div key={i} className="bg-[#fbf6ee] rounded-2xl p-7 border-l-4 border-[#b81d24]">
              <div className="w-12 h-12 rounded-full bg-[#b81d24] text-white flex items-center justify-center mb-4">
                <c.icon className="w-6 h-6" />
              </div>
              <h3 className="font-extrabold text-xl text-gray-900 mb-3">{c.title}</h3>
              {c.lines.map((l, k) => (
                <p key={k} className={`text-gray-700 ${l === siteInfo.hours.emergency ? "font-bold text-[#b81d24] mt-2" : ""}`}>{l}</p>
              ))}
            </div>
          ))}
        </div>
      </section>

      <section className="pb-20 px-4 bg-[#f3ece0]">
        <div className="max-w-7xl mx-auto py-16 grid lg:grid-cols-2 gap-10">
          <div className="rounded-2xl overflow-hidden shadow-md h-[520px]">
                      <iframe title="Clinic location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.9415709498217!2d77.7229009753146!3d28.989102375471926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c64fb1aee75bb%3A0x111aab9eededb034!2sDr.%20Mamtesh%20Gupta!5e0!3m2!1sen!2sin!4v1779779292714!5m2!1sen!2sin" className="w-full h-full border-0" loading="lazy" />
          </div>
          <div>
            <p className="font-script text-emerald-700 text-2xl mb-1">Book Appointment</p>
            <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-2">Contact Us Today!</h3>
            <p className="text-gray-600 mb-6">We will reply you within 24 hours via email, thank you for contacting</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name*" className="w-full bg-white rounded-full px-5 py-3.5 border border-amber-100 focus:outline-none focus:ring-2 focus:ring-[#b81d24]" />
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email*" className="w-full bg-white rounded-full px-5 py-3.5 border border-amber-100 focus:outline-none focus:ring-2 focus:ring-[#b81d24]" />
                <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone*" className="w-full bg-white rounded-full px-5 py-3.5 border border-amber-100 focus:outline-none focus:ring-2 focus:ring-[#b81d24]" />
                <select value={form.service} onChange={(e) => setForm({ ...form, service: e.target.value })} className="w-full bg-white rounded-full px-5 py-3.5 border border-amber-100 focus:outline-none focus:ring-2 focus:ring-[#b81d24]">
                  <option value="">Select Service</option>
                  {serviceOptionsForForm.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <textarea rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Message..." className="w-full bg-white rounded-2xl px-5 py-3.5 border border-amber-100 focus:outline-none focus:ring-2 focus:ring-[#b81d24]" />
              <label className="flex items-center gap-2 text-sm text-gray-600">
                <input type="checkbox" checked={form.agree} onChange={(e) => setForm({ ...form, agree: e.target.checked })} className="w-4 h-4 accent-[#b81d24]" />
                Agree to our terms and conditions
              </label>
              <button type="submit" disabled={!form.agree} className="inline-flex items-center gap-2 bg-[#b81d24] hover:bg-[#9a1820] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold px-7 py-3.5 rounded-full transition-colors">
                Send Message <ArrowRight className="w-4 h-4" />
              </button>
              {sent && <p className="text-emerald-700 font-semibold">Thank you! Your message has been received.</p>}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
